import Vue from 'vue'
import Router from 'vue-router'
import accueil from './components/Pages/accueil.vue'
import buffetPar from './components/Pages/buffetPar.vue'
import buffetPro from './components/Pages/buffetPro.vue'
import cocktailPro from './components/Pages/cocktailPro.vue'
import cocktailPar from './components/Pages/cocktailPar.vue'
import contact from './components/Pages/contact.vue'
import equipe from './components/Pages/equipe.vue'
import esprit from './components/Pages/esprit.vue'
import location from './components/Pages/location.vue'
import evenements from './components/Pages/evenements.vue'
import mariage from './components/Pages/mariage.vue'
import pauses from './components/Pages/pauses.vue'
import portage from './components/Pages/portage.vue'
import repasPar from './components/Pages/repasPar.vue'
import repasPro from './components/Pages/repasPro.vue'
import vosgesTerroir from './components/Pages/vosgesTerroir.vue'
import actualites from './components/Pages/actualites.vue'
import plateau from './components/Pages/plateau.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: accueil
        },
        {
            path: '/buffet-traiteur',
            name: 'buffetPar',
            component: buffetPar
        },
        {
            path: '/buffet-entreprise',
            name: 'buffetPro',
            component: buffetPro
        },
        {
            path: '/cocktail-professionnels',
            name: 'cocktailPro',
            component: cocktailPro
        },
        {
            path: '/cocktail-particuliers',
            name: 'cocktailPar',
            component: cocktailPar
        },
        {
            path: '/contact',
            name: 'contact',
            component: contact
        },
        {
            path: '/equipe',
            name: 'equipe',
            component: equipe
        },
        {
            path: '/esprit',
            name: 'esprit',
            component: esprit
        },
        {
            path: '/location-materiel-traiteur',
            name: 'location',
            component: location
        },
        {
            path: '/evenements-entreprises',
            name: 'evenements',
            component: evenements
        },
        {
            path: '/traiteur-mariage',
            name: 'mariage',
            component: mariage
        },
        {
            path: '/pause-dejeuner',
            name: 'pauses',
            component: pauses
        },
        {
            path: '/portage-repas',
            name: 'portage',
            component: portage
        },
        {
            path: '/repas-particuliers',
            name: 'repasPar',
            component: repasPar
        },
        {
            path: '/repas-professionnels',
            name: 'repasPro',
            component: repasPro
        },
        {
            path: '/label-vosges-terroir',
            name: 'vosgesTerroir',
            component: vosgesTerroir
        },
        {
            path: '/actualites',
            name: 'actualites',
            component: actualites
        },
        {
            path: '/plateaux-repas-entreprise',
            name: 'plateau',
            component: plateau
        },
    ]
})
